import {useTranslation} from "react-i18next";

const IsLegalEntityRadioButtons = (
    {isLegalEntity, setIsLegalEntity}:
        {isLegalEntity: boolean, setIsLegalEntity: (arg0: boolean) => void}
) => {

    const { t } = useTranslation();

    return (
        <>
            <div className="form-group">
                <label className="radio-inline" style={{marginRight: '5px'}} htmlFor="individual_person">
                    <input type="radio"
                           id="individual_person"
                           name="individual_person"
                           checked={!isLegalEntity}
                           style={{marginRight: '5px'}}
                           onChange={() => setIsLegalEntity(false)} />
                    {t('individual_person')}
                </label>
                <label className="radio-inline" htmlFor="legal_entity">
                    <input type="radio"
                           id="legal_entity"
                           name="legal_entity"
                           checked={isLegalEntity}
                           style={{marginRight: '5px'}}
                           onChange={() => setIsLegalEntity(true)} />
                    {t('legal_entity')}
                </label>
            </div>
        </>
    )
}

export default IsLegalEntityRadioButtons;
